export class OrganizationKeyDetails {
  constructor(
    private readonly id: number,
    private readonly shortDescription: string,
    private readonly valueJson: object | null,
    private readonly hasPrivateKey: boolean | null,
    private readonly metadata: object | null
  ) {}

  getId() {
    return this.id;
  }

  getShortDescription() {
    return this.shortDescription;
  }

  getValueJson() {
    return this.valueJson;
  }

  getHasPrivateKey() {
    return this.hasPrivateKey;
  }

  getMetadata() {
    return this.metadata;
  }
}
